(function () {
  var CLOSE_AFTER_MS = 2500;
  var closeTimer = null;

  function openCartDrawer() {
    // Archetype/Impulse supports dev-friendly events
    try { document.dispatchEvent(new Event('cart:open')); } catch(e) {}

    // Fallback: click a dedicated cart drawer opener if present (avoid plain /cart links)
    var opener =
      document.querySelector('[data-cart-drawer-open]') ||
      document.querySelector('[data-drawer-open="cart"]') ||
      document.querySelector('button[aria-controls*="Cart"], button[aria-label*="Cart"], button[aria-label*="cart"]');

    if (opener && opener.tagName !== 'A') opener.click();

    // Auto-close (tries common close buttons) — also supports cart:close
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      try { document.dispatchEvent(new Event('cart:close')); } catch(e) {}

      var closer =
        document.querySelector('[data-cart-drawer-close]') ||
        document.querySelector('[data-drawer-close="cart"]') ||
        document.querySelector('[data-drawer-close]') ||
        document.querySelector('button[aria-label*="Close"], button[aria-label*="close"]');

      if (closer) closer.click();
    }, CLOSE_AFTER_MS);
  }

  // Listen for the theme’s “item added” signals
  document.addEventListener('ajaxProduct:added', openCartDrawer);
  document.addEventListener('product:added', openCartDrawer);
  document.addEventListener('cart:updated', openCartDrawer);
})();
